// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recommendedVideos-module--wrapper--1WTwN"};